/**
 * URL path'inden kategori ID'sini tespit eder
 * @param {string} pathname - URL pathname (örn: /warranty-management/warranty-process-forms/...)
 * @returns {string|null} - Kategori ID'si veya null
 */
export const detectCategoryFromPath = (pathname) => {
    // Ana sayfa veya user-params sayfasındaysak kategori seçmeyelim
    if (pathname === '/' || pathname === '/user-params') {
        return null;
    }

    // Tam yol override'ları - Kredi Kartı kategorisi altındaki sayfalar /parts altında
    // yaşadığı için ilk segment ("parts") order-management'a düşmesin diye özel eşleme.
    const exactPathOverrides = {
        '/parts/credit-card-collection': 'credit-card-collection',
        '/parts/collection-report': 'credit-card-collection'
    };
    if (exactPathOverrides[pathname]) {
        return exactPathOverrides[pathname];
    }

    // URL'in ilk segmentine göre kategori belirle
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length === 0) return null;

    const firstSegment = segments[0];

    // URL segment'lerine göre kategori mapping
    const categoryMap = {
        // Management paths
        'management': 'management',
        
        // Dealer Management paths
        'dealer-management': 'dealer-management',
        
        // Warranty Management paths
        'warranty-management': 'warranty-management',
        
        // Reports paths
        'reports': 'reports',
        
        // Order Management paths
        'order-management': 'order-management',
        'parts': 'order-management',
        'basket': 'order-management',
        
        // Full Service paths
        'full-service-invoices': 'full-service-invoices',
        'full-service': 'full-service-invoices'
    };

    return categoryMap[firstSegment] || null;
};

/**
 * Tüm kategori ID'lerinin listesi
 */
export const CATEGORY_IDS = {
    MANAGEMENT: 'management',
    DEALER_MANAGEMENT: 'dealer-management',
    WARRANTY_MANAGEMENT: 'warranty-management',
    REPORTS: 'reports',
    ORDER_MANAGEMENT: 'order-management',
    FULL_SERVICE: 'full-service-invoices'
};

